$(function () {
    $('#categorySelect').on('change', function () {
        var tab = '#tab' + $(this).val();
        $('.tab-pane').removeClass('show').removeClass('active');
        $(tab).addClass('show').addClass('active');
    });
    $('.category-item').on('click', function () {
        var tab = $(this).data('tab');
        $('.tab-pane').removeClass('show').removeClass('active');
        $(tab).addClass('show').addClass('active')
        $('.category-item').removeClass('active');
        $(this).addClass('active')
    });
    $('.model-title').on('click', function (e) {
        var id = $(this).data('id')
        templateClickGa(id)
    })
});